import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { withStyles } from 'material-ui/styles';
import FaqHeader from './FaqHeader';
import FaqNavigation from './FaqNavigation';
import FaqIndex from './FaqIndex';
import HowToLetterSend from './HowToLetterSend';
import HowToSalesforce from './HowToSalesforce';
import HowToFaq from './HowToFaq';
import "../../assets/css/react-smooth-scroll.css";

const styles = () => ({
  root: {
    width: '100%',
    background: "#FFFFFF",
    lineHeight: '1.5em',
  },

  main: {
    marginBottom: '60px',
  },

  mainContainer: {
    display: 'flex',
    marginTop: '40px',
    width: '100%',
  },

  left: {
    width: '820px',
    marginLeft: '100px',
  },

  right: {
    paddingLeft: '40px',
    width: '300px',
    position: 'fixed',
    left: '920px',
    letterSpacing: '0.25px',
    textIndent: '0.25px',
    height: '100%',
  },

  desc: {
    fontSize: 15,
    paddingBottom: '10px',
    fontWeight: 'bold',
    letterSpacing: '0.27px',
    textIndent: '0.27px',
  },

  anchorLink: {
    fontSize: 13,
    marginTop: '10px',
    cursor: 'pointer',
    letterSpacing: '0.25px',
    textIndent: '0.25px',
    lineHeight: '1.5em',
    '&:hover': {
      color: '#195AFF',
    }
  },

  faqDesc: {
    fontSize: 15,
    paddingBottom: '10px',
    fontWeight: 'bold',
    letterSpacing: '0.3px',
    textIndent: '0.3px',
    '&:hover': {
      color: '#195AFF',
    }
  },

  breadcrumb: {
    padding: '10px 40px',
    fontSize: 13,
    letterSpacing: '0.25px',
    textIndent: '0.25px',
  },

  link: {
    color: '#5F6368',
    textDecoration: 'none',
    paddingRight: '5px',
    '&:hover': {
      color: '#195AFF',
    }
  },

  list: {
    height: 'calc(100% - 320px)',
    overflow: 'auto',
    width: '100%',
  },

  empty: {
    height: '30px',
  }
});

class Faq extends React.Component {
  state = {
    showFaqNavigation: false,
    howToType: '',
    howToPage: '',
  }

  componentDidMount() {
    if (this.props.location.pathname) {
      this.changeHowToPage();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location.pathname &&
      this.props.location.pathname &&
      prevProps.location.pathname !== this.props.location.pathname
    ) {
      this.changeHowToPage();
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    }
  }

  goToHashLink = (hash) => {
    window.location.hash = '';
    window.location.hash = hash;
  }

  changeHowToPage = () => {
    const { location } = this.props;
    let howToType = '';
    let howToPage = '';

    if (location.pathname.indexOf('send-letter') !== -1) {
      howToType = 'レター送付ガイド';
      if (location.pathname.indexOf('guide') !== -1) {
        howToPage = 'Keyman Letter入稿ガイド';
      } else if (location.pathname.indexOf('tips') !== -1) {
        howToPage = 'レター書き方Tips';
      } else if (location.pathname.indexOf('qrcode') !== -1) {
        howToPage = 'QRコードの効果的な活用方法';
      }
    } else if (location.pathname.indexOf('salesforce') !== -1) {
      howToType = 'Salesforce連携';
      if (location.pathname.indexOf('connect-account') !== -1) {
        howToPage = 'アカウント連携方法';
      } else if (location.pathname.indexOf('operation') !== -1) {
        howToPage = 'レター送付のSalesforceの運用のイメージ';
      } else if (location.pathname.indexOf('duplication') !== -1) {
        howToPage = 'Salesforceとのデータの重複について';
      }
    } else if (location.pathname.indexOf('faq') !== -1) {
      howToType = 'よくある質問';
      howToPage = 'よくある質問';
    }

    this.setState({
      howToType: howToType,
      howToPage: howToPage,
    });
  }

  handleDownloadFile = (isSecondVer) => {
    let url = process.env.REACT_APP_KEYMAN_LETTER_TEMPLATE_FILE_URL
    if (isSecondVer) {
      url = process.env.REACT_APP_KEYMAN_LETTER_TEMPLATE_FILE2_URL
    }
    window.open(url);
  };

  toggleFaqNavigation = () => {
    this.setState({
      showFaqNavigation: !this.state.showFaqNavigation,
    });
  };

  render() {
    const { classes, location } = this.props;
    const paddingDefault = 125;
    const paddingHowTo = 135;
    return (
      <div className={classes.root}>
        {this.state.showFaqNavigation &&
          <FaqNavigation
            goTo={this.props.goTo}
            toggleFaqNavigation={this.toggleFaqNavigation}
          />
        }
        <FaqHeader
          goTo={this.props.goTo}
          title={this.state.howToType}
          toggleFaqNavigation={this.toggleFaqNavigation}
        />
        <div className={classes.main} style={{ pointerEvents: this.state.showFaqNavigation ? 'none' : 'unset', paddingTop: this.state.howToType ? paddingHowTo : paddingDefault }}>
          {(this.state.howToPage && this.state.howToPage !== 'よくある質問') && (
            <div className={classes.breadcrumb}>
              <Link
                to={location.pathname.substr(0, location.pathname.lastIndexOf('/'))}
                className={classes.link}
              >
                {this.state.howToType}
              </Link>
              ＞ <span style={{ fontWeight: 'bold' }}>{this.state.howToPage}</span>
            </div>
          )}
          {(this.state.howToPage && this.state.howToPage === 'よくある質問') && (
            <div className={classes.empty}></div>
          )}
          <div className={classes.mainContainer}>
            <div className={classes.left}>
              {!this.state.howToPage && (
                <FaqIndex
                  goTo={this.props.goTo}
                  howToType={this.state.howToType}
                  handleDownloadFile={this.handleDownloadFile}
                />
              )}
              {this.state.howToType === 'レター送付ガイド' && this.state.howToPage && (
                <HowToLetterSend
                  goTo={this.props.goTo}
                  howToMenu={this.state.howToPage}
                  handleDownloadFile={this.handleDownloadFile}
                />
              )}
              {this.state.howToType === 'Salesforce連携' && this.state.howToPage && (
                <HowToSalesforce
                  goTo={this.props.goTo}
                  howToMenu={this.state.howToPage}
                />
              )}
              {this.state.howToType === 'よくある質問' && this.state.howToPage && (
                <HowToFaq
                  goTo={this.props.goTo}
                  howToMenu={this.state.howToPage}
                />
              )}
            </div>
            <div className={classes.right}>
              {this.state.howToPage === 'Keyman Letter入稿ガイド' && (
                <div className={classes.list}>
                  <div className={classes.desc}>Keyman Letter入稿ガイド</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#guide1')}>入稿データの拡張子について</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#guide2')}>用紙サイズ・ページ数について</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#guide3')}>雛形について</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#guide4')}>フォントについて</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#guide5')}>可変テキストについて</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#guide6')}>入稿データについて</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#guide7')}>トラッキングQRコードの設定手順について</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#guide8')}>添付物について</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#guide9')}>発送予定日、到着予定日について</div>
                </div>
              )}
              {this.state.howToPage === 'レター書き方Tips' && (
                <div className={classes.list}>
                  <div className={classes.desc}>レター書き方Tips</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#tips1')}>日付について</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#tips2')}>時候の挨拶</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#tips3')}>文面の作り方</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#tips4')}>QRコードの追加</div>
                </div>
              )}
              {this.state.howToPage === 'QRコードの効果的な活用方法' && (
                <div className={classes.list}>
                  <div className={classes.desc}>QRコードの効果的な活用方法</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#qrcode1')}>主なQRコードのリンク先</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#qrcode2')}>QRコードの近くにリンク先の情報について記載する</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#qrcode3')}>効果的なレターを書く</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#qrcode4')}>トラッキングQRコードの設定手順について</div>
                </div>
              )}
              {this.state.howToPage === 'アカウント連携方法' && (
                <div className={classes.list}>
                  <div className={classes.desc}>アカウント連携方法</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#connect-account1')}>1. 【Salesforce】連携中のユーザのユーザプロファイルを確認</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#connect-account2')}>2. 【Salesforce】Salesforceシステム権限管理者の方に、権限設定の変更を依頼</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#connect-account3')}>3. 【Salesforce】現ユーザー(システム権限管理者とは限らない)の項目レベルセキュリティの設定</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#connect-account4')}>4. 【Keyman Letter】アカウント管理画面から［Salesforceと連携］</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#connect-account5')}>5. 【Keyman Letter】Salesforce連携設定</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#connect-account6')}>6. 【Keyman Letter】アカウント管理ページに戻り、同期ボタンを押す</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#connect-account7')}>7. 【Keyman Letter】注文履歴画面で同期したいキャンペーンを選択して［Salesforceに同期］</div>
                </div>
              )}
              {this.state.howToPage === 'レター送付のSalesforceの運用のイメージ' && (
                <div className={classes.list}>
                  <div className={classes.desc}>レター送付のSalesforceの運用のイメージ</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#operation1')}>1. 送付したいキーマンを選択し、レター送付ボタンを押す</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#operation2')}>2. レター送付画面でSalesforceに同期するにチェック</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#operation3')}>3. 注文を確定</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#operation4')}>4. 注文履歴に「Salesforceと同期中」と表示されているのを確認</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#operation5')}>5. Salesforce上で同期されているのを確認</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#operation6')}>6. QRコードの読み込みがあった場合</div>
                </div>
              )}
              {this.state.howToPage === 'Salesforceとのデータの重複について' && (
                <div className={classes.list}>
                  <div className={classes.desc}>Salesforceとのデータの重複について</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#duplication1')}>1. レター送付先のキーマンが自社リストと重複する場合について</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#duplication2')}>2. Salesforceと同期した後、Salesforceで新規の登録データが重複する場合について</div>
                </div>
              )}
              {this.state.howToPage === 'よくある質問' && (
                <div className={classes.list}>
                  <div className={classes.faqDesc} onClick={() => this.goToHashLink('#faq-exe')}>キーマンデータベース検索でよくあるご質問</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#faq-exe1')}>特定の会社名で検索すると、検索結果が少ないような場合がありますが、不具合ですか？
                  </div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#faq-exe2')}>法人番号一括検索で、検索にヒットした法人はどれで、ヒットしなかったのはどれかというのを確認できますか？
                  </div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#faq-exe3')}>DUNSナンバーで検索できますか？
                  </div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#faq-exe4')}>第三者への個人情報の削除、および提供の停止することはできますか
                  </div>
                  <div className={classes.faqDesc} style={{ marginTop: 50 }} onClick={() => this.goToHashLink('#faq-ordering')}>レター注文時によくあるご質問</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#faq-ordering1')}>データ送付前にどのキーマンが選択されているか、Excel等で一覧で見たいのですが可能ですか？
                  </div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#faq-ordering2')}>QRコードは複数設置することはできますか？
                  </div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#faq-ordering3')}>QRコードのURLを入力したが、入稿データにはQRコードを挿入し忘れてしまいました。
                  </div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#faq-ordering4')}>自社で保有しているリストで担当者名が分からず、宛名を「ご担当者様」のような形で送付する事は可能ですか？
                  </div>
                  <div className={classes.faqDesc} style={{ marginTop: 50 }} onClick={() => this.goToHashLink('#faq-after-order')}>レター注文後によくあるご質問</div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#faq-after-order1')}>キャンセルしたい場合はどうすればいいですか？
                  </div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#faq-after-order2')}>レターが届いたかどうかわかりますか？
                  </div>
                  <div className={classes.anchorLink} onClick={() => this.goToHashLink('#faq-after-order3')}>手紙を送付しましたが、退任されたとのことで返却されました。
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Faq.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object,
  goTo: PropTypes.func,
};

export default withStyles(styles)(Faq);



// WEBPACK FOOTER //
// ./src/components/Faq/Faq.jsx